import React, { useContext, useState, useEffect } from 'react';
import styles from './Highscore.module.scss';
import { SettingsContext } from '../../contexts/settings-provider';
import { database } from '../../utils/firebase';
import { ref, get, query, orderByValue, limitToLast } from 'firebase/database';
import PropTypes from 'prop-types';
import CountUp from 'react-countup';

import emojiList from '../../data/emoji.json';
import classNames from 'classnames';
import Heading from '../../components/Heading/Heading';
import Loading from '../../components/Loading/Loading';

const Highscore = ({ length }) => {
  const [settings] = useContext(SettingsContext);
  const [highscore, setHighscore] = useState([]);

  useEffect(() => {
    const highscoreRef = query(
      ref(database, `highscore`),
      orderByValue(),
      limitToLast(length)
    );
    get(highscoreRef)
      .then((snapshot) => {
        const highscoreList = snapshot.val();
        const newHighscore = [];
        for (const key in highscoreList) {
          const own = settings.user && key === settings.user.uid;
          newHighscore.push({ own: own, key: key, points: highscoreList[key] });
        }
        setHighscore(
          newHighscore.sort((a, b) => {
            if (a.points > b.points) {
              return -1;
            } else {
              return 1;
            }
          })
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, [settings.user, length]);

  const highscoreList = highscore.map((score, i) => {
    return (
      <div
        key={score.key}
        className={classNames(styles.score, {
          [styles.own]: score.own === true,
        })}
      >
        <div className={styles.number}>#{i + 1}</div>
        {score.own && <div className={styles.you}>Your score!</div>}
        <div className={styles.points}>
          <CountUp end={score.points} duration={1} /> / {emojiList.length}{' '}
        </div>
      </div>
    );
  });

  if (highscore.length === 0) {
    return <Loading />;
  } else {
    return (
      <div className={styles.highscore}>
        <Heading className={styles.title}>
          Top {highscore.length} global players
        </Heading>
        <div className={styles.list}>{highscoreList}</div>
      </div>
    );
  }
};

Highscore.propTypes = {
  length: PropTypes.number,
};

Highscore.defaultProps = {
  length: 5,
};

export default Highscore;
